
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25.746","height":"26.746","viewBox":"0 0 26.746 26.746"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',[_c('circle',{attrs:{"cx":"13.373","cy":"13.373","fill":"#fb2121","r":"13.373"}}),_c('path',{staticClass:"b",attrs:{"d":"M18.043 18.468l-.425.212a1.291 1.291 0 01-1.7 0l-8.064-8.066a1.291 1.291 0 010-1.7l.212-.212a1.291 1.291 0 011.7 0l8.066 8.066a1.122 1.122 0 01.211 1.7z"}}),_c('path',{staticClass:"b",attrs:{"d":"M8.067 18.68l-.212-.212a1.291 1.291 0 010-1.7l8.066-8.066a1.291 1.291 0 011.7 0l.212.212a1.291 1.291 0 010 1.7L9.767 18.68a1.291 1.291 0 01-1.7 0z"}})])])
          )
        }
      }
    